export default __webpack_public_path__ + "static/media/f_button.3befdf13.svg";